var map = {
	"./daniel": 32,
	"./daniel.jpg": 32,
	"./felipe": 43,
	"./felipe.jpg": 43,
	"./suporte": 33,
	"./suporte.png": 33,
	"./thiago": 44,
	"./thiago.jpg": 44,
	"./tiago": 45,
	"./tiago.png": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 325;